<div class="mwp-modal">
    <div class="header">
        <mwp-text-translate text="CONFIRM LOGOUT" jsonKey="confirmLogoutTitle" />
    </div>
    <div class="body">
        <div class="message-card">
            <mwp-text-translate text="Please confirm if you wish to log out." jsonKey="confirmLogout" />
        </div>
    </div>
    <div class="footer">
        <button class="mwp-button w-100 mb-3" (click)="logout()">
            <mwp-text-translate text="Logout" jsonKey="logout" />
        </button>
        <button class="mwp-button-secondary w-100" (click)="close()">
            <mwp-text-translate text="CANCEL" jsonKey="cancel" />
        </button>
    </div>
</div>